module.exports = __webpack_public_path__ + "static/media/plate-cutlery.3307c83b.svg";